import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
export default function getmasterData(){
  const Authorization='bearer '+localStorage.getItem('token');
  fetch(`${API_URL}getridermasterdata`,{
    headers:{"Content-Type": "application/json",Accept,Authorization}
  }
  ).then(function(response){
      return response.json();
  }).then(function(result){
    localStorage.setItem('getMasterData',JSON.stringify(result[0].data));
  })
}



// WEBPACK FOOTER //
// ./src/utility/api/getMasterData.js